import * as Sentry from '@sentry/browser';
import Promise from 'promise-polyfill';
import React from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { CompatRouter } from "react-router-dom-v5-compat";

import Home from './components/home';
import SocketProvider from './components/socketProvider';
import { SENTRY_DSN } from '../Shared/utils/constants';
import BackOff from './utils/backOff';
import createStore from './utils/configureStore';

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

if (window.postbuildEnv.RAILS_ENV === 'production') {
  Sentry.init({ dsn: SENTRY_DSN, environment: 'production' })
} else if (window.postbuildEnv.RAILS_ENV === 'staging') {
  Sentry.init({ dsn: SENTRY_DSN, environment: 'staging' })
}

BackOff();
const store = createStore();

const route = (
  <CompatRouter>
    <Switch>
      <Route component={Home} path="/" />
    </Switch>
  </CompatRouter>
);

const App = () => (
  <Provider store={store}>
    <SocketProvider>
      <HashRouter basename="/">{route}</HashRouter>
    </SocketProvider>
  </Provider>
)

export default App
